import React from 'react';

// Lightweight full-screen confetti drop — pure CSS, no dependencies.
// Render conditionally for ~4-5s; pieces animate once and fade out.
const COLORS = ['#f9c74f', '#6f42c1', '#f472b6', '#34d399', '#60a5fa', '#fb923c'];

const Confetti = () => (
  <div style={{position:'fixed', inset:0, pointerEvents:'none', zIndex:3000, overflow:'hidden'}} aria-hidden="true">
    <style>{`
      @keyframes db-confetti-fall {
        0%   { transform: translateY(-8vh) rotate(0deg); opacity: 1; }
        100% { transform: translateY(108vh) rotate(660deg); opacity: 0.4; }
      }
    `}</style>
    {Array.from({ length: 60 }).map((_, i) => (
      <div key={i} style={{
        position: 'absolute',
        top: 0,
        left: `${(i * 53) % 100}%`,
        width: i % 3 === 0 ? '12px' : '8px',
        height: i % 3 === 0 ? '6px' : '10px',
        borderRadius: i % 2 === 0 ? '2px' : '50%',
        background: COLORS[i % COLORS.length],
        animation: `db-confetti-fall ${2.6 + (i % 5) * 0.5}s linear ${(i % 10) * 0.18}s forwards`,
      }} />
    ))}
  </div>
);

export default Confetti;
